export default "__VITE_ASSET__DgPQzStu__"